import {JSX, useCallback, useEffect, useState} from "react";
import {eventerConsoleApiClient, Invitation} from "../../../../api-client/EventerConsoleApiClient.ts";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {EventerConsoleNavigation} from "../../../../EventerConsoleNavigation.tsx";
import {Alert, Box, Button, Typography} from "@mui/material";
import {AppFwError, handleError} from "../../../../../appfw/api-client/AppFwApiClient.ts";
import {useAccountOpt} from "../Accounts.tsx";
import FullSizeBox from "../../../../../appfw/ui/components/FullSizeBox.tsx";

export default function InvitationPage() {

    const navigate = useNavigate()
    const location = useLocation()

    const {accountId, invitationId} = useParams<{ accountId: string, invitationId: string }>()
    const accountOpt = useAccountOpt()

    const [invitation, setInvitation] = useState<undefined | Invitation>(undefined)
    const [error, setError] = useState<null | AppFwError>()

    const accept = useCallback(async () => {
        if (!accountId || !invitationId) {
            return
        }
        setError(null)
        try {
            await eventerConsoleApiClient.acceptInvitation({accountId, invitationId})
            EventerConsoleNavigation.accounts.account(accountId).navigate(navigate, location, true)
        } catch (e) {
            let error = await handleError(e)
            if (error.errorRecords?.find((error) => error.code === "common.not-found")) {
                // invitation not found, redirect to accounts page
                error = {
                    ...error,
                    message: "Einladung nicht gefunden. Möglicherweise wurde sie bereits angenommen oder ist abgelaufen.",
                }
            }
            setError(error)
        }
    }, [accountId, invitationId, setError])

    useEffect(() => {
        const abortController = new AbortController()

        if (!accountId || !invitationId) {
            console.error("Missing accountId or invitationId in params")
            return EventerConsoleNavigation.accounts.navigate(navigate)
        }

        eventerConsoleApiClient.getInvitation({accountId, invitationId})
            .then((invitation) => {
                setInvitation(invitation)
            })
            .catch(async (e) => {

                console.log("!!!", e)
                const error = await handleError(e);
                console.log("!!! 2", error);
                if (error.errorRecords?.find((error_1) => error_1.code === "common.not-found")) {
                    // invitation not found, redirect to accounts page
                    setError({
                        ...error,
                        message: "Einladung ist ungültig. Möglicherweise wurde sie bereits angenommen oder ist abgelaufen.",
                    });
                } else {
                    setError(error);
                }
            })

        return () => {
            abortController.abort()
        }
    }, [accountId, invitationId, setError, setInvitation])

    useEffect(() => {
        if (accountId && accountId === accountOpt?.id) {
            // already member from this account, redirect to the account page
            return EventerConsoleNavigation.accounts.account(accountId).navigate(navigate, location, true)
        }
    }, [accountId, accountOpt])

    if (invitation === undefined && error === null) {
        return
    }

    let textEl: JSX.Element | undefined
    if (invitation) {

        textEl = (
            <Typography>
                Du wurdest eingeladen, dem Eventer-Account "<strong>{invitation?.podName}</strong>" beizutreten.
            </Typography>
        )

        const inviterName = invitation?.inviter?.name
        if (inviterName && inviterName.length > 0) {
            textEl = (
                <Typography>
                    {inviterName} hat Dich eingeladen, dem
                    Eventer-Account <strong>"{invitation?.podName}"</strong> beizutreten.
                </Typography>
            )
        }

    } else if (error) {
        textEl = (
            <Typography>
                Du wurdest eingeladen, der Eventer Plattform beizutreten.
            </Typography>
        )
    }

    return (
        <FullSizeBox centerVertically>
            <Box sx={{padding: 4}} textAlign={"center"}>

                {textEl}

                {error && (<Alert severity="error" sx={{marginTop: 3}}>{error.message}</Alert>)}

                {invitation && (
                    <Button onClick={accept} sx={{marginTop: 4}}>
                        <Typography>Beitreten</Typography>
                    </Button>
                )}
            </Box>
        </FullSizeBox>
    )
}